const riot = require('riot');

riot.tag2('atom-input-raffle-preview', '<div class="mb20" data-is="atom-tabs" ref="tabs" items="{getTabs()}" current="general"></div> <div class="f"> <div class="w-full pr40"> <div class="mb20"> <div class="ts-hxs text-gray_80 mb8">メイン画像</div> <div class="ts-ps text-gray_60 mb20">利用できる画像は最大5MBまでです。横幅800px以上を推奨します。画像形式に制限はありません。</div> <label class="f fm cursor-pointer mb20" if="{needCheckboxCloseAtDisplay()}"> <input class="checkbox mr10" type="checkbox" checked="{getCurrentData().close_at_display_disabled}" onchange="{bindRaffleRuleByChecked(&quot;close_at_display_disabled&quot;)}"><span class="ts-ps text-navy">抽選受付終了日を表示しない</span> </label> <div class="f ft mb8" if="{hasImageOfCurrent()}"> <div class="ts-ps text-gray_60 word-break-all mr8">{getImageNameOfCurrent()}</div> <div class="flex-fixed icon-close fs24 cursor-pointer hover-only-text-gray_60" if="{!opts.readonly}" onclick="{removeRaffleImage}"></div> </div> <div class="f fl"> <div data-is="atom-input-image" disabled="{opts.readonly}"> <button class="button flex-fixed" type="button" disabled="{parent.opts.readonly}"><span class="icon-photograph fs24 text-gray_30 mr4"></span><span>画像を選択</span></button> </div> </div> </div> <div class="mb20"> <div class="ts-hxs text-gray_80 mb8">フリーテキスト</div> <textarea class="textarea w-full" placeholder="フリーテキストを入力" rows="4" riot-value="{getCurrentData().description}" oninput="{bindRaffleRule(&quot;description&quot;)}" maxlength="2000" readonly="{opts.readonly}"></textarea> </div> <div if="{needButtonTextEditor()}"> <div class="ts-hxs text-gray_80 mb8">ボタンテキスト</div> <input class="input w-full" placeholder="ボタンのテキストを入力" riot-value="{getCurrentData().button_text}" oninput="{bindRaffleRule(&quot;button_text&quot;)}" maxlength="100" readonly="{opts.readonly}"> </div> </div> <div class="w320 flex-fixed"> <div class="ts-hxs text-gray_80 mb8">プレビュー</div> <div class="ts-ps text-gray_60 mb8">実際の表示とは異なる可能性があります</div> <div class="min-height-460 rounded-8 px24 py32 border border-gray_10"> <div class="mb80"> <div if="{refs.tabs.current === &quot;general&quot;}"> <div class="mb24 {\'square\': !refs.image.complete}" if="{getCurrentImageURL()}"><img class="block w-full object-fit-contain" ref="general_image" riot-src="{getCurrentImageURL()}" alt="メイン画像" onload="{_.noop}"></div> <div class="text-center mb24"> <div class="ts-ps" if="{getCurrentData().description}" data-is="atom-anchorify" text="{getCurrentData().description}"></div> </div> <div class="text-center ts-ps text-gray_60 mb34" if="{!getCurrentData().close_at_display_disabled}">抽選受付終了日: {dayjs(getCurrentData().close_at).format(\'YYYY年M月D日\')} 23時59分</div> <div class="f fc"> <button class="button primary raffle word-break-all" type="button">{getCurrentData().button_text}</button> </div> </div> <div if="{refs.tabs.current !== &quot;general&quot;}"> <div class="mb24 {\'square\': !refs.result_image.complete}" if="{getCurrentImageURL()}"><img class="block object-fit-contain" ref="result_image" riot-src="{getCurrentImageURL()}" alt="メイン画像" onload="{_.noop}"></div> <div class="text-center mb16"> <div class="ts-ps" if="{getCurrentData().description}" data-is="atom-anchorify" text="{getCurrentData().description}"></div> </div> <div if="{this.needButtonTextEditor()}"> <div class="f fc"> <button class="button primary size-l" type="button">{getCurrentData().button_text}</button> </div> </div> <div if="{refs.tabs.current === opts.length - 1}"></div> </div> </div> <div class="flex-fixed pt16"> <p class="text-gray_60 ts-pxs mb8">※本キャンペーンは{opts.campaign.contact_name}が運営しております。ご不明点などありましたら、(<span class="text-primary_dark_10"> {opts.campaign.contact_email}</span><span if="{opts.campaign.contact_email &amp;&amp; opts.campaign.contact_site}"> または </span><span class="text-primary_dark_10">{opts.campaign.contact_site}</span> )までお問い合わせください。</p> <p class="text-gray_60 ts-pxs mb16">※本キャンペーンにおける特典の配布は、Repro株式会社の運営するポイント配布サービス「Repro Incentive」が代行しております。</p> <p class="text-center text-gray_30 ts-pxs">Powered by Repro Incentive</p> </div> </div> </div> </div>', 'atom-input-raffle-preview,[data-is="atom-input-raffle-preview"]{display:block}', '', function(opts) {
    this.on('mount', () => {

      if (this.opts.general) {
        const {
          button_text,
          description,
          image_path,
          image_url,
          close_at_display_disabled,
          close_at,
        } = this.opts.general;

        this.generalRaffleRule = {
          button_text,
          description,
          image_path,
          image_name: image_path,
          image_url: image_path ? image_url : '',
          close_at_display_disabled,
          close_at,
        };
      }

      if (this.opts.rules) {
        this.raffleRules = this.opts.rules.map(({ description, button_text, url: image_url, image_path }) => {
          if (!image_path) image_url = '';
          return { description, button_text, image_url, image_path, image_name: image_path };
        });
      }

      if (!this.raffleRules) {
        const DEFAULT_RAFFLE_PATTERNS_LENGTH = 2;

        this.raffleRules = [...Array(DEFAULT_RAFFLE_PATTERNS_LENGTH)].map(() => this.getDefaultRaffleRule());
      }

      if (!this.generalRaffleRule) {
        this.generalRaffleRule = {
          button_text: "くじを引く",
          description: "",
          close_at_display_disabled: false,
          image_path: "",
        };
      }
    });

    this.on('tabChange', () => {
      this.update();
    });

    this.on('fileset', ({ url, file }) => {
      Object.assign(this.getCurrentData(), {
        file,
        image_url: url,
      });
      this.update();
    });

    this.addTab = (index) => {
      const current = this.refs.tabs.current;
      this.raffleRules.splice(index, 0, this.getDefaultRaffleRule());
      if (current !== 'general' && current >= index) {
        this.refs.tabs.current++;
      }
      this.update();
    };

    this.removeTab = (index) => {
      const current = this.refs.tabs.current;
      this.raffleRules.splice(index, 1);
      if (current !== 'general' && current >= index) {
        this.refs.tabs.current--;
      }
      this.update();
    };

    this.getDefaultRaffleRule = () => {
      return {
        description: "",
        image_path: "",
        button_text: "ポイントの受取",
      };
    };

    this.getTabs = () => {
      const tabs = [
        {
          id: 'general',
          label: '抽選画面',
          showToggleCloseAtDisplay: true,
          showButtonTextInput: true,
        }
      ];

      const length = this.opts.length;
      tabs.push(...Array.from({ length }).map((n, i) => {
        return {
          id: i,
          label: `抽選結果${i + 1}`,
          showToggleCloseAtDisplay: false,
          showButtonTextInput: true,
        };
      }));

      tabs[tabs.length - 1].label = this.opts.isAllWin ? '抽選終了' : 'ハズレ';

      tabs[tabs.length - 1].showButtonTextInput = false;
      return tabs;
    };

    this.needCheckboxCloseAtDisplay = () => {
      return this.getTabs().find(i => i.id === this.refs.tabs.current)?.showToggleCloseAtDisplay;
    };

    this.needButtonTextEditor = () => {
      return !!this.getTabs().find(i => i.id === this.refs.tabs.current)?.showButtonTextInput;
    };

    this.getDataByID = (tab_id) => {
      if (tab_id === 'general') return this.generalRaffleRule;
      return this.raffleRules[tab_id];
    };

    this.getCurrentData = () => {
      const current = this.refs.tabs.current;
      return this.getDataByID(current);
    };

    this.removeRaffleImage = () => {
      Object.assign(this.getCurrentData(), {
        file: null,
        image_url: null,
      });
    };

    this.bindRaffleRule = (key, tab_id) => {
      return (e) => {
        const data = tab_id != null ? this.getDataByID(tab_id) : this.getCurrentData();
        data[key] = e.target.value;
        this.bubbleTrigger('datachange');
      };
    };

    this.bindRaffleRuleByChecked = (key, tab_id) => {
      return (e) => {
        const data = tab_id != null ? this.getDataByID(tab_id) : this.getCurrentData();
        data[key] = e.target.checked;
        this.bubbleTrigger('datachange');
      };
    }

    this.hasImageOfCurrent = () => {
      const current = this.getCurrentData();
      return !!(current.file || current.image_url);
    };

    this.getImageNameOfCurrent = () => {
      const current = this.getCurrentData();
      return (current.file && current.file.name) || current.image_name;
    };

    this.getCurrentImageURL = () => {
      return this.getCurrentData().image_url;
    };

    this.getValue = ({ image_api } = {}) => {

      const IMAGE_MAX_SIZE = 5 * 1024 * 1024;
      const IMAGE_MIN_SIZE = 0;

      return Promise.all([

        (async () => {
          let image_path = "";
          const rule = this.generalRaffleRule;
          if (rule.file) {
            image_path = await app.utils.uploadImage({
              file: rule.file,
              api: image_api,
              limit: {
                max: IMAGE_MAX_SIZE,
                min: IMAGE_MIN_SIZE,
              }
            });
            if (!image_path) {
              throw new Error(`${rule.file.name} のアップロードに失敗しました`);
            }
          }

          else if (rule.image_url) {
            image_path = rule.image_path;
          }
          return {
            close_at: dayjs(rule.close_at).endOf('date').valueOf(),
            close_at_display_disabled: rule.close_at_display_disabled,
            image_path,
            description: rule.description,
            button_text: rule.button_text,
          };
        })(),

        Promise.all(this.raffleRules.map(async (rule, i) => {
          let image_path = "";
          if (rule.file) {
            image_path = await app.utils.uploadImage({
              file: rule.file,
              api: image_api,
              limit: {
                max: IMAGE_MAX_SIZE,
                min: IMAGE_MIN_SIZE,
              }
            });
            if (!image_path) {
              throw new Error(`${rule.file.name} のアップロードに失敗しました`);
            }
          }

          else if (rule.image_url) {
            image_path = rule.image_path;
          }

          return {
            image_path,
            description: rule.description,
            button_text: rule.button_text,
          };
        }))
      ]);
    };
});